import { render } from "./AiUsageMcp.vue?vue&type=template&id=36a8d95b&scoped=true"
import script from "./AiUsageMcp.vue?vue&type=script&lang=js"
export * from "./AiUsageMcp.vue?vue&type=script&lang=js"

import "./AiUsageMcp.vue?vue&type=style&index=0&id=36a8d95b&scoped=true&lang=css"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36a8d95b"]])

export default __exports__